import React, { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import ActivitiesCard from "./ActivitiesCard";

const RecentActivitySummary = (props) => {
  

  return (
    <HeaderComponent
      title="Recent Activity"
      titleClass="text-[16px] font-medium"
      description="Latest credit awards and transactions"
      descriptionClass="text-sm muted-text"
    >
      <div className="max-h-[600px] overflow-y-auto">
        <ActivitiesCard/>
      </div>
    </HeaderComponent>
  );
};

export default RecentActivitySummary;
